import { COMMON_MIXPANEL_PAGE } from '../../common/constants/mixpanelConstants'
import { UTM_CAMPAIGN } from '../../common/constants/utm'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const googlePerformanceMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.GOOGLE_PERFORMANCE,
  iFrameSrcUrl: '/google-performance-coaching',
  micrositeUrl: 'performance',
  title: {
    id: 'googlePerformance.title',
    defaultMessage: 'Exclusive performance coaching and tools',
    description: 'Microsite page title',
  },
  featureFlag: 'isGooglePerformanceEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_PROVIDER_BOOKING },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS },
    { key: CMS_MICROSITE_MESSAGE_KEY.OPEN_EXTERNAL_LINK },
  ],
  page: COMMON_MIXPANEL_PAGE.PERFORMANCE_HUB_MICROSITE,
  trackUTMParams: {
    utm_campaign: UTM_CAMPAIGN.GOOGLE_CRITICAL_TALENT,
  },
  shouldSupportSpanish: true,
  shouldHideForInternational: false,
  usePageForViewEvent: true,
}
